import { Injectable } from '@angular/core';
import { CommandContentActions, CommandContentApiActions } from './command-content.actions';
import { MdmCommandProgressService } from '@rocksoft/mdm-sdk-v2';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class CommandContentEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: MdmCommandProgressService
  ) {}

  loadCommandContentEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CommandContentActions.commandContentRequested),
      mergeMap(({ udid, commandUuid }) =>
        safeMap(
          this.api.getCommandContent(udid, commandUuid, '2.0'),
          (commandContent) => CommandContentApiActions.commandContentLoaded({ commandContent }),
          (error) => CommandContentApiActions.commandContentLoadedError({ error })
        )
      )
    );
  });
}
